import axios from 'axios';
import { API2_HOST } from '../../helpers/urlHelper';
import { baseSearch, basePatch } from 'services/base-services/baseService';

axios.defaults.withCredentials = true;
const baseURL = `${API2_HOST}/sls-wpo-discrepancies`;

const search = async request => {
  return await baseSearch(`${baseURL}`, request);
};

const getDiscrepancyImages = async grnNo => {
  var fullURL = `${API2_HOST}/attachments/s3?recordId=${grnNo}&app=delivery.note.sls.app`;

  const res = await axios({
    url: fullURL,
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return res;
};

const resolvedDiscrepancy = async id => {
  return await basePatch(baseURL, { status: 1 }, id);
};

export { search, getDiscrepancyImages, resolvedDiscrepancy };
